import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { fa } from 'vuetify/locale'
import { aliases, custom } from './icons'

const vuetify = createVuetify({
  components,
  directives,
  locale: {
    rtl: { fa: true },
    locale: 'fa',
    messages: {
      fa,
    },
  },
  icons: {
    defaultSet: 'custom',
    aliases,
    sets: {
      custom,
    },
  },

  defaults: {
    VTextField: {
      variant: 'outlined',
      color: 'primary',
      density: 'compact',
      rounded: 'lg',
      bgColor: 'white',
    },
    VAutocomplete: {
      variant: 'outlined',
      color: 'primary',
      density: 'compact',
      rounded: 'lg',
      bgColor: 'white',
    },
    VTextarea: {
      variant: 'outlined',
      color: 'primary',
      density: 'compact',
      rounded: 'lg',
      bgColor: 'white',
    },
    VSelect: {
      variant: 'outlined',
      color: 'primary',
      density: 'compact',
      rounded: 'lg',
      bgColor: 'white',
    },
    VBtn: {
      color: 'primary',
      style: 'letter-spacing: 0px',
      class: ['rounded-lg elevation-0'],
    },
    VListItem: {
      ripple: false,
    },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          white: '#FFFFFF',

          primary: '#BD7A28',
          'primary-30': '#F7F3EB',
          'primary-50': '#F7F1E2',
          'primary-100': '#ECDBB7',
          'primary-200': '#E0C589',
          'primary-300': '#D5AE5E',
          'primary-400': '#CE9F42',
          'primary-500': '#C79033',
          'primary-600': '#C3872E',
          'primary-800': '#B56D24',
          'primary-900': '#A95B20',
          'primary-950': '#3A1E08',

          secondary: '#9EA712',
          'secondary-50': '#EEF0D7',
          'secondary-100': '#DEE1B0',
          'secondary-200': '#CED388',
          'secondary-300': '#BEC461',
          'secondary-400': '#AEB539',
          'secondary-600': '#838B0F',
          'secondary-700': '#696F0C',
          'secondary-800': '#4F5309',
          'secondary-900': '#343706',
          'secondary-950': '#1A1B03',

          'gray-50': '#F9F9F9',
          'gray-100': '#EDEDED',
          'gray-200': '#D9D9D9',
          'gray-300': '#CBCBCB',
          'gray-300-20': '#2A5B69',
          'gray-400': '#ADADAD',
          'gray-500': '#868686',
          'gray-600': '#606060',
          'gray-700': '#404040',
          'gray-800': '#262626',
          'gray-900': '#171717',
          black: '#000000',
          background: '#F4F4F7',
          'gray-background': '#FAF9F6',

          'blue-gray-30': '#F7FBFC',
          'blue-gray-50': '#F2F7FA',
          'blue-gray-100': '#E0EBF0',
          'blue-gray-400': '#A5C1CE',
          'blue-gray-500': '#93B5C3',
          'blue-gray-600': '#84A3AF',
          'blue-gray-700': '#738C97',
          'blue-gray-800': '#647780',
          'blue-gray-200': '#CDDEE6',
          'blue-gray-300': '#B8D0DA',
          'blue-gray-900': '#516067',
          'blue-gray-950': '#293135',

          accent: '#242468',

          // set base theme color gray-600 with opacity dont change this
          'on-surface': '#2B2E31',
          'success-100': '#E6EFCE',
          'success-600': '#6B9408',
          'success-700': '#567C06',

          'warning-600': '#D69F05',

          rhino: '#363672',

          warning: '#FF7931',

          info: '#5384FF',
          'info-10': '#E5EDFF',
          'info-dark': '#4278FF',

          error: '#F62F51',
          'error-dark': '#D71E3D',

          success: '#09CF5C',
          'success-dark': '#1DB25B',
        },
      },
    },
  },
})

export default vuetify
